(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("fil-lib-riskminder", [], factory);
	else if(typeof exports === 'object')
		exports["fil-lib-riskminder"] = factory();
	else
		root["fil-lib-riskminder"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition